import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseTabInterface } from '../../../shared/interfaces/base-tab.interface';
import { IsActiveMatchOptions } from '@angular/router';
import { BaseApplicationSectionsInterface } from '../../../shared/interfaces/base-application-sections.interface';

@Component({
  selector: 'base-vertical-nav',
  templateUrl: './base-vertical-nav.component.html',
})
export class BaseVerticalNavComponent {
  @Input() tabs: BaseApplicationSectionsInterface[] = [];
  @Input() withArrow = false;
  @Input() isResponsive = false;
  @Input() isUppercaseTitle = true;
  @Input() isCentralisedForSmallScreen = false;
  @Input() preventRouteChange = false;
  @Input() avoidActiveTabHighlight = false;
  @Input()
  @Output()
  currentChange = new EventEmitter<BaseTabInterface>();

  routerLinkActiveOptions: IsActiveMatchOptions = {
    queryParams: 'ignored',
    matrixParams: 'exact',
    paths: 'exact',
    fragment: 'exact',
  };
  private value: BaseTabInterface;

  get current(): BaseTabInterface {
    return this.value;
  }
  set current(value) {
    this.value = value;

    if (this.value) {
      this.currentChange.emit(this.value);
    }
  }

  onTabSelect(tab: BaseTabInterface): void {
    this.current = tab;
  }
}
